module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_4_01-e3553913d4240d98a1a5411c59eb9b4e.jpg";